import { z } from 'zod';

export type RetainMarker = z.infer<typeof RetainMarker>;

export const RetainMarker = z.object({
    app: z.string(),
    reason: z.string(),
    createdOn: z.coerce.date(),
});
